import React from 'react';
import { TriangleAlert } from 'lucide-react';
import { useSurveyStore } from '../store/useSurveyStore';

const Error = () => {
	const { errorCode } = useSurveyStore();
	const isInvalidToken = errorCode === 'invalid_token';

	return (
		<div className="flex justify-center">
			<div className="bg-white rounded-xl border border-[#EEEEEE] p-6 m-4 w-max">
				<div className="flex flex-col items-center text-center">
					<TriangleAlert className="text-red-500 mb-2" size={36} />
					{isInvalidToken ? (
						<p className="max-w-sm">
							This assessment may have already been opened once before. Please ask your care provider to send it again. You may close this window.
						</p>
					) : (
						<>
							<p>Something went wrong. You may close this window.</p>
							{errorCode && <p className="text-xs text-[#999999]">Error Code: {errorCode}</p>}
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default Error; 